import * as actions from '@xmatters/redux/actions/addUsersToGroup';

export const defaultState = {
  show: false,
  submitting: false,
  error: undefined,
};

export default function addUsersToGroup(state = defaultState, action) {
  switch (action.type) {
    case actions.ADD_USERS_TO_GROUP_MODAL_SHOW:
      return {
        ...state,
        show: true,
        showPrompt: action.payload?.showPrompt,
      };
    case actions.ADD_USERS_TO_GROUP_MODAL_HIDE:
      return {
        ...state,
        show: false,
      };
    case actions.INVITE_CREATE_GROUP_START:
      return {
        ...state,
        submitting: true,
      };
    case actions.INVITE_CREATE_GROUP_SUCCESS:
      return {
        ...state,
        submitting: false,
        show: false,
      };
    case actions.INVITE_CREATE_GROUP_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case actions.SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: action.payload,
      };
    default:
      return state;
  }
}
